import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense } from "react";
const LazyAddress = lazy(() => import("./Address.index"));
const AddressComponent = (props) => (_jsx(Suspense, { fallback: null, children: _jsx(LazyAddress, { ...props }) }));
export default AddressComponent;
